'use client';
import React from 'react';
import { Button, Icon } from '@benzinga/core-ui';
import { SmartLink } from '@benzinga/analytics';
import { faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';
import { Event } from '@benzinga/events-manager';
import classnames from 'classnames';
import {
  FusionEventsCalendar,
  FusionSection,
  FusionSectionContent,
  FusionSectionTitle,
  FusionSectionStyles,
} from '@benzinga/ui';

import styles from '../styles.module.scss';

interface IProps {
  events: Event[];
}

const EventsCalendar = ({ events }: IProps) => {
  return (
    <>
    <FusionSection sectionPadding={false}>
      <FusionSectionContent paddingHorizontal={false} sectionPadding>
        <div className={styles.eventsCalendarHeader}>
          <FusionSectionTitle className="title mb-0">EVENTS CALENDAR</FusionSectionTitle>
          <SmartLink className={styles.eventsCalendarDesktopLink} href="/events">
            <Button className={styles.eventsCalendarButton} size="fusion-md" variant="fusion-outline">
              MORE EVENTS
              <Icon icon={faArrowRightLong} />
            </Button>
          </SmartLink>
        </div>
      </FusionSectionContent>
      <FusionSectionContent className="pb-12" paddingHorizontal={false} paddingVertical={false}>
        <FusionEventsCalendar events={events} maxCardsCount={6} />
        <SmartLink
          className={classnames(
            'events-link block w-full pt-6',
            FusionSectionStyles.fusionSectionContentPadding,
            styles.eventsCalendarMobileLink,
          )}
          href="/events"
        >
          <Button
            className={classnames(styles.eventsCalendarButton, 'w-full')}
            size="fusion-md"
            variant="fusion-outline"
          >
            MORE EVENTS
            <Icon icon={faArrowRightLong} />
          </Button>
        </SmartLink>
      </FusionSectionContent>
    </FusionSection>
  </>
  );
};  

export default EventsCalendar;
